// extracted by mini-css-extract-plugin
module.exports = {"root":"Container_root__VrakX"};